import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { WebMailConfigRequest, WebMailConfigResponse } from './config-email.model';

@Injectable({ providedIn: 'root' })
export class ConfigEmailService extends BaseService {
    readonly PATH = SICOM_PATHS.sistema.configEmail;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(context?: HttpContext): Observable<WebMailConfigResponse | null> {
        return this.http.get<WebMailConfigResponse | null>(this.PATH, { context });
    }

    salvar(request: WebMailConfigRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(this.PATH, request, { context });
    }
}
